import React, { Component } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import moment from 'moment';
import { Link, Navigate } from 'react-router-dom';
import API from "../../config/api";
import { exportToExcel } from "../Helper/exportToExcel";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { newDate } from 'react-datepicker/dist/date_utils';

export class SellReport extends Component {

  constructor(props) {
    super(props);
    this.state = {
      nb_days: 15,
      data: [],
      nav_id: null,
      date: new Date(),
      startDate: null,
      endDate: null,
      nb_sale_30days: [],
      last_month_sell: null,
      last_week_sell: null,
      top_video: [],
      total_sell: null,
      yesterday_sell: null

    }
  }

  componentWillMount() {
    this.getData();
    this.getSaleReport();
  }


  searchByDate = (range) => {
    const [startDate, endDate] = range;
    this.setState({startDate})
    this.setState({endDate})

    console.log(startDate, endDate)

    this.getSaleReport();
    // setStartDate(startDate);
    // setEndDate(endDate);
  };

  getRamdom() {
    return Math.floor(Math.random() * 1000) + 3000
  }

  getDay(i) {
    // return moment().subtract(i, 'months').format("MMM YYYY")
    return moment().subtract(i, 'day').format("DD")
  }

  getData() {
    let tempArray = []
    for (let i = this.state.nb_days; i > 0; i--) {
      tempArray.push({
        key: i,
        sell_per_month: this.getRamdom(),
        name: this.getDay(i)
      })
    }
    this.setState({data: tempArray})
  }

  exportSaleToExcel = (data, filename) => {
    exportToExcel(data, filename);
  }

  getSaleReport = async () => {
    try {
      // let query = `page=${this.state.page}`
      // moment().format("MMM Do YY");
      let query ='';
      let start_date = '';
      let end_date = '';
      
      if(this.state.startDate) {
        start_date = moment(this.state.startDate).format("YYYY-MM-DD");
        end_date = moment(this.state.endDate).format("YYYY-MM-DD");
      }
      

      console.log(start_date, end_date, this.state.nb_days)
      // let query = `nb_days=14`
      
      if(this.state.nb_days) {
        console.log(this.state.nb_days)
        query = `nb_days=${this.state.nb_days}`
      }

      if(start_date) {
        console.log(start_date)
        query = `start_date=${start_date}&&end_date=${end_date}`
      }

      // this.query = `start_date=${start_date}&&end_date=${end_date}`

      let results = await API.getSellReport();
      let data = results.data
      console.log(data, 'sell report')

      let tempArray = []

      for (let i = data.sale_30days.length -1 ; i > -1; i--) {  
        tempArray.push({
          key: i,
          // active_users: this.getRamdom(),
          sale_30days: data.sale_30days[i],
          name: this.getDay(i+1)
        })
      }
      
      this.setState({data : tempArray, nb_sale_30days: data.sale_30days, last_month_sell: data.last_month_sell.toLocaleString('en-US'), last_week_sell: data.last_week_sell.toLocaleString('en-US'),
        top_video: data.top_video, total_sell: data.total_sell.toLocaleString('en-US'), yesterday_sell: data.yesterday_sell.toLocaleString('en-US')
       });

    } catch (error) {
      console.log(error)
    }
  }

  render() {
    
    return (
      <div class="col-md-12">
        {/* {this.state.nav_id && (
           <Navigate to={`/videoview?id=${this.state.nav_id}`} replace={true} />
        )} */}
            <div class="card">
              <div className="card-body">

                <div className="flexbox mb-20">
                    <div className="lookup">
                      {/* <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} /> */}
                      <DatePicker
                        className="w-300px"
                        showIcon
                        icon="fa fa-calendar"
                        selected={this.state.startDate}
                        onChange={this.searchByDate}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        // minDate={this.state.startDate}
                        placeholderText="Select specific day"
                        dateFormat="MMMM d, yyyy"
                        isClearable
                        selectsRange
                      />

                    </div>

                    <div className="btn-toolbar">
                      <div className="btn-group btn-group-sm">
                      
                      <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Export</button>
                        <div className="dropdown-menu dropdown-menu-right">
                            <Link class="dropdown-item"  ><i class="fa fa-file-zip-o"></i> Zip</Link>
                            <Link class="dropdown-item"  ><i class="fa fa-file-pdf-o"></i> PDF</Link>
                            <Link class="dropdown-item" onClick={(event) => {this.exportSaleToExcel(this.state.top_video, "top sale report")}}  ><i class="fa fa-file-excel-o"></i> Excel</Link>
                        </div>
                        <select data-provide="selectpicker" data-width="100">
                          <option>Today</option>
                          <option>Yesterday</option>
                          <option>Last week</option>
                          <option>Last month</option>
                          <option>All time</option>
                        </select>
                      </div>
                    </div>
                  </div>
                <div>
               </div>
              </div>

              <div className='row'>
                <div class="col-md-6 col-xl-3">
                  <div class="card card-body">
                  <h6>
                  <span class="text-uppercase">Yesterday</span>
                  <span class="float-right"><a class="btn btn-xs btn-primary" href="#">View</a></span>
                  </h6>
                  <br />
                  <p class="fs-28 fw-100">${this.state.yesterday_sell}</p>

                    <div class="progress">
                      <div class="progress-bar bg-danger" role="progressbar" style={{width: "35%", height: "4px"}} aria-valuenow="35" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <div class="text-gray fs-12"><i class="ti-stats-down text-success mr-1"></i> %18 decrease from last month</div>
                  </div>
                </div>

                <div class="col-md-6 col-xl-3">
                  <div class="card card-body">
                    <h6>
                      <span class="text-uppercase">Last week</span>
                      <span class="float-right"><a class="btn btn-xs btn-primary" href="#">View</a></span>
                    </h6>
                    <br />
                    <p class="fs-28 fw-100">${this.state.last_week_sell}</p>
                    <div class="progress">
                      <div class="progress-bar" role="progressbar" style={{width: "65%", height: "4px"}} aria-valuenow="65" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <div class="text-gray fs-12"><i class="ti-stats-up text-success mr-1"></i> 324 more than last year</div>
                  </div>
                </div>

                <div class="col-md-6 col-xl-3">
                  <div class="card card-body">
                    <h6>
                      <span class="text-uppercase">Last month</span>
                      <span class="float-right"><a class="btn btn-xs btn-primary" href="#">View</a></span>
                    </h6>
                    <br />
                    <p class="fs-28 fw-100">${this.state.last_month_sell}</p>
                    <div class="progress">
                      <div class="progress-bar bg-warning" role="progressbar" style={{width: "65%", height: "4px"}} aria-valuenow="65" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <div class="text-gray fs-12"><i class="ti-arrow-down text-danger mr-1"></i> %32 down</div>
                  </div>
                </div>

                <div class="col-md-6 col-xl-3">
                  <div class="card card-body">
                    <h6>
                      <span class="text-uppercase">Year</span>
                      <span class="float-right"><a class="btn btn-xs btn-primary" href="#">View</a></span>
                    </h6>
                    <br />
                    <p class="fs-28 fw-100">${this.state.last_month_sell}</p>
                    <div class="progress">
                      <div class="progress-bar bg-success" role="progressbar" style={{width: "85%", height: "4px"}} aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <div class="flexbox text-gray fs-12">
                      <span><i class="ti-arrow-up text-success mr-1"></i> %25 up</span>
                      <span>+1000</span>
                    </div>
                  </div>
                </div>
              </div>
              </div>

              {/* Sell per month */}
              <div className='card'>
              <div class="card-header">
            <h5 class="card-title"><strong>User Report</strong></h5>
            <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
          {/* <Link class="btn btn-xs btn-light" to=''>See all</Link> */}
            

            {/* <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Export</button>
            <div className="dropdown-menu dropdown-menu-right">
                <Link class="dropdown-item"  ><i class="fa fa-file-zip-o"></i> Zip</Link>
                <Link class="dropdown-item"  ><i class="fa fa-file-pdf-o"></i> PDF</Link>
                <Link class="dropdown-item"  ><i class="fa fa-file-excel-o"></i> Excel</Link>
            </div>
            <select data-provide="selectpicker" data-width="100">
              <option>Yesterday</option>
              <option>Last week</option>
              <option>Last month</option>
              <option>All time</option>
            </select> */}
                
            </div>
          </div>

                <div class="card-body card-body">
              {
                this.state.data.length != 0 && 
                <div  style={{width: '100%', height: 300 }}>
                <ResponsiveContainer debounce={300} width="100%" height="100%">
                  <BarChart
                    width={500}
                    height={300}
                    data={this.state.data}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                    barSize={20}
                  >
                    <XAxis dataKey="name" scale="point" padding={{ left: 10, right: 10 }} />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <CartesianGrid strokeDasharray="3 3" />
                    <Bar dataKey="sale_30days" fill="#4ed2c5" background={{ fill: '#eee' }} />
                  </BarChart>
                </ResponsiveContainer>
                </div>
              }
                </div>
              </div>

              <div className='card'>
                <div class="card-header">
                  <h5 class="card-title"><strong>Top sale</strong></h5>
                  <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
                {/* <Link class="btn btn-xs btn-light" to=''>See all</Link> */}
                  

                  {/* <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Export</button>
                  <div className="dropdown-menu dropdown-menu-right">
                      <Link class="dropdown-item"  ><i class="fa fa-file-zip-o"></i> Zip</Link>
                      <Link class="dropdown-item"  ><i class="fa fa-file-pdf-o"></i> PDF</Link>
                      <Link class="dropdown-item"  ><i class="fa fa-file-excel-o"></i> Excel</Link>
                  </div>
                  <select data-provide="selectpicker" data-width="100">
                    <option>Today</option>
                    <option>Yesterday</option>
                    <option>Last week</option>
                    <option>Last month</option>
                    <option>All time</option>
                  </select> */}
                  
                </div>
                
              </div>

              {/* <div class="card-body bl-3 border-success flexbox flex-justified">
                <div>
                  <div class="fs-12 text-muted"><i class="ti-time mr-1"></i> 24 hours</div>
                  <div class="fs-18 text-success">26 Sales</div>
                </div>

                <div>
                  <div class="fs-12 text-muted"><i class="ti-time mr-1"></i> 7 days</div>
                  <div class="fs-18 text-danger">134 Sales</div>
                </div>

                <div class="fs-40 fw-100 text-right pr-2 text-success">$106</div>
              </div> */}

              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Title</th>
                  <th >Episode</th>
                  <th>Release Date</th>
                  <th >Total</th>
                  <th class="w-80px text-center">Action</th>
                </tr>
              </thead>
                <tbody>
                { this.state.top_video &&
                this.state.top_video.map((data, index) => {
                  return <tr>
                    <td>{index+1}</td>
                    <td>{data.title_kh}</td>
                    <td className="text-muted w-120px">{data.nb_episodes}</td>
                    <td>{moment(data.release_date).format("DD-MMM-YYYY")}</td>
                    <td className="text-success fw-500 w-80px">${data.sale.toLocaleString('en-US')}</td>
                    <td>
                      <nav class="nav no-gutters gap-2 fs-16">
                        <Link class="nav-link hover-primary" title="View" to={`/videoview?id=${data.id}`} data-provide="tooltip" ><i class="ti-eye"></i></Link>
                        {/* <a class="nav-link hover-danger" href="#" data-provide="tooltip" title="Delete"><i class="ti-trash"></i></a> */}
                      </nav>
                    </td>
                  </tr> 
                  })
                }
                </tbody>
              </table>
              </div>

                    
              
          </div>
    )
  }
}

export default SellReport